export enum SliceNameEnum {
    Accommodation = 'mfeAccommodation',
    AccommodationRatings = 'mfeAccommodationRatings',
    AccommodationStatic = 'mfeAccommodationStatic',
    CommonUiState = 'mfeCommonUiState',
    CheckoutDetails = 'mfeCheckoutDetails',
    CheckoutReservation = 'mfeCheckoutReservation',
    CmsGlobal = 'cmsGlobal',
    CmsHomepage = 'cmsHomepage',
    CreatePayment = 'mfeCreatePayment',
    ReservationDetails = 'mfeReservationDetails',
    Autocomplete = 'autocomplete',
    Homepage = 'homepage',
    Map = 'map',
    MapAccommodation = 'mapAccommodation',
    UserProfile = 'appUserProfile',
}
